import React from 'react';
import PropTypes from 'prop-types';

// components
import { shippingModal as messages } from '../shippingMessages';

// styles
import styles from './ShippingDetailsText.scss';

export function ShippingDetailsRequestQuote(props) {
    const { openQuoteRequestModal, quoteRequestStatus, blockRequest } = props;

    return (
        <div className={styles.detailsCaptions}>
            {quoteRequestStatus !== 'customQuoteProvided' && !blockRequest && (
                <p className={styles.detailsCaption}>
                    <span className={styles.requestText}>{messages.requestShippingQuote}</span>
                    <span
                        className={styles.requestLink}
                        onClick={openQuoteRequestModal}
                        data-tn="shipping-request-open-quote-modal"
                    >
                        {messages.requestShippingQuoteLink}
                    </span>
                </p>
            )}
            {quoteRequestStatus !== 'customQuoteProvided' && blockRequest && (
                <p className={styles.detailsCaption}>{messages.blockRequest}</p>
            )}
            <p className={styles.detailsCaption}>{messages.customerArranged}</p>
        </div>
    );
}

ShippingDetailsRequestQuote.propTypes = {
    openQuoteRequestModal: PropTypes.func.isRequired,
    quoteRequestStatus: PropTypes.string.isRequired,
    blockRequest: PropTypes.bool,
};
